import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

const APA_CONFIGURATION_QUERY_KEY = 'apa-configuration';

export const getApaConfigQueryKey = (orgId?: string, clusterId?: string) =>
  [APA_CONFIGURATION_QUERY_KEY, orgId, clusterId] as const;

const getApaConfigQueryOptions = ({
  organizationId,
  clusterId,
  enabled = true,
}: {
  organizationId?: string;
  clusterId: string;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: getApaConfigQueryKey(organizationId, clusterId),
    queryFn: async () => {
      const { data } = await apiClient.apa.getConfig({
        organizationId: organizationId!,
        clusterId,
      });
      return data;
    },
    enabled: enabled && !!organizationId && !!clusterId,
  });

type UseApaConfigQueryProps = {
  clusterId: string;
  enabled?: boolean;
};

export const useApaConfigQuery = ({
  clusterId,
  enabled = true,
}: UseApaConfigQueryProps) => {
  const { currentOrganization } = useOrganizations();

  const { data, isLoading, error, refetch } = useQuery(
    getApaConfigQueryOptions({
      organizationId: currentOrganization?.id,
      clusterId,
      enabled,
    })
  );

  return { config: data, isLoading, error, refetch };
};
